const QCuentaMask = (value) => {
    let newVal = value.replaceAll('-', '').replaceAll(' ', '')
    newVal = newVal.substring(0,15)
    return newVal
}

export default QCuentaMask